/**
 * @desc 查看环保监测图标曲线
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.EPMonitorRequest,
): Promise<defs.StandardReturn<defs.EnvironmentalMonitoringCurveResponse>> {
  return defHttp.post({
    url: '/wap/monitoring/queryEpMonitorCurve',
    data,
  });
}

export function mock(
  data: defs.EPMonitorRequest,
): Promise<defs.StandardReturn<defs.EnvironmentalMonitoringCurveResponse>> {
  return defHttp.post({
    url: '/mock/wap/monitoring/queryEpMonitorCurve',
    data,
  });
}
